import { Appointment, TaskListItem, TimeManagementListItem } from '@myapp/contract'

export function getDayRange(dayIso: string) {
  const base = new Date(dayIso)
  return {
    from: new Date(base.getFullYear(), base.getMonth(), base.getDate(), 0, 0, 0, 0).toISOString(),
    to: new Date(base.getFullYear(), base.getMonth(), base.getDate(), 23, 59, 59, 999).toISOString(),
  }
}

export function findAppointmentById(
  technicians: { appointments: Appointment[] }[],
  id: string,
): Appointment | undefined {
  for (const t of technicians) {
    const found = t.appointments.find((a) => a.id === id)
    if (found) return found
  }
  return undefined
}

export interface DefaultDurations {
  plannedTravelDuration: number
  plannedWorkDuration: number
  plannedDepartureDuration: number
}

const BREAK_DURATION_MS = 30 * 60_000

export function calculateBlockRangeFromDurations(
  anfahrtStartIso: string,
  durations: DefaultDurations,
): { start: number; end: number } {
  const startMs = new Date(anfahrtStartIso).getTime()
  const totalMs =
    (durations.plannedTravelDuration + durations.plannedWorkDuration + durations.plannedDepartureDuration) * 60_000
  return { start: startMs, end: startMs + totalMs }
}

export function calculateBlockRangeFromAppointment(appt: Appointment): { start: number; end: number } {
  const workStart = new Date(appt.actualStart ?? appt.plannedStart).getTime()
  const travelDuration = appt.actualTravelDuration ?? appt.plannedTravelDuration
  const workDuration = appt.actualWorkDuration ?? appt.plannedWorkDuration
  const departureDuration = appt.actualDepartureDuration ?? appt.plannedDepartureDuration
  const start = workStart - travelDuration * 60_000
  const end = workStart + (workDuration + departureDuration) * 60_000
  return { start, end }
}

export function calculateBlockRangeFromTask(task: TaskListItem): { start: number; end: number } {
  const workStart = new Date(task.actualStart ?? task.plannedStart!).getTime()
  const travelDuration = task.actualTravelDuration ?? task.plannedTravelDuration
  const workDuration = task.actualWorkDuration ?? task.plannedWorkDuration
  const departureDuration = task.actualDepartureDuration ?? task.plannedDepartureDuration
  const start = workStart - travelDuration * 60_000
  const end = workStart + (workDuration + departureDuration) * 60_000
  return { start, end }
}

export function calculateBreakRange(breakStartIso: string): { start: number; end: number } {
  const start = new Date(breakStartIso).getTime()
  return { start, end: start + BREAK_DURATION_MS }
}

export function calculateBlockRangeFromTimeManagement(
  entry: TimeManagementListItem,
  dayIso: string,
): { start: number; end: number } {
  const dayStart = new Date(dayIso + 'T00:00:00').getTime()
  const dayEnd = new Date(dayIso + 'T23:59:59.999').getTime()
  const start = Math.max(new Date(entry.startTime).getTime(), dayStart)
  const end = Math.min(new Date(entry.endTime).getTime(), dayEnd)
  return { start, end }
}
